import type { IChip } from 'www/vue_components/common/TheFilters/doctors/stores/useChipsStore.types'

/**
 * Функция сортирует чипы фильтров:
 *  - чип меню должен идти самым первым
 *  - активные чипы должны идти самыми первыми
 *  - все чипы должны быть отсортированы по порядковому номеру
 * @param {any} a -
 * @param {any} b -
 */
function sortChipsFilters(a: IChip, b: IChip) {
  if (a.menuChip !== b.menuChip) {
    return b.menuChip ? 1 : -1
  }

  if (a.isActive !== b.isActive) {
    return b.isActive ? 1 : -1
  }

  return a.order - b.order
}

export default sortChipsFilters
